import { Alert } from '@mui/material'
import i18next from 'i18next'
import { t } from 'i18next'
import { closeModal, closePopup, showModal } from 'actions/app'
import {
  harvestsByYearFetched,
  addSingleFeatureToHarvest as addSingleFeatureToHarvestAction,
  setHarvestFeatures,
  harvestFetched,
  updateHarvestById,
  harvestHeadersFetched,
  harvestYearsFetched,
  harvestsFetched,
  harvestsAFetched,
  harvestsBFetched,
} from 'actions/harvest'

import { setYear } from 'api/field'
import http from 'common/http'
import { getYearsWithHarvests } from 'common/misc'
import RequestReceived from 'components/admin/bulk-export/request-received'
import CreateHarvestRequestSent from 'components/harvest/create-harvest-request-sent'

export const getHarvestsByYear = (year) => {
  return (dispatch) => {
    const params = { params: { year: year } }
    return http.get('/harvest', params).then((res) => {
      dispatch(harvestsByYearFetched(res.data))
    })
  }
}

export const getHarvestsByFarm = (farmId, year) => {
  return (dispatch) => {
    const params = { params: { farmId: farmId, year: year } }
    return http.get('/harvest', params).then((res) => {
      dispatch(harvestsByYearFetched(res.data))
    })
  }
}

export const getHarvestsByClient = (clientId, year) => {
  return (dispatch) => {
    const params = { params: { clientId: clientId, year: year } }
    return http.get('/harvest', params).then((res) => {
      dispatch(harvestsByYearFetched(res.data))
    })
  }
}

export const addSingleFeatureToHarvest = (idHarvest, feature) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + idHarvest + '/features', feature)
      .then((res) => {
        dispatch(addSingleFeatureToHarvestAction(res.data))
        dispatch(closePopup())
      })
  }
}

export const updateSingleFeatureOfHarvest = (idHarvest, feature) => {
  return (dispatch) => {
    return http.put('/harvest/' + idHarvest + '/features', feature).then(() => {
      dispatch(closePopup())
    })
  }
}

export const getHarvestFeatures = (idHarvest) => {
  return (dispatch) => {
    return http.get('/harvest/' + idHarvest + '/features').then((res) => {
      dispatch(setHarvestFeatures(res.data))
    })
  }
}

export const editHarvest = (id, payload, refresh = true) => {
  return (dispatch) => {
    const url = '/harvest/' + id
    let params: any | null = null
    if (!refresh) {
      params = { params: { refresh: false } }
    }
    return http.put(url, payload, params).then((res) => {
      dispatch(harvestFetched(res.data))
      dispatch(updateHarvestById(res.data, payload))
    })
  }
}

export const updateTotalYield = (id, totalYield, totalYieldUnit) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + id + '/total-yield', {
        totalYield: totalYield,
        totalYieldUnit: totalYieldUnit,
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch(updateHarvestById(res.data, res.data))
          dispatch(harvestFetched(res.data))
        }
        dispatch(closeModal())
      })
  }
}

// The override endpoints answer 202: the harvest is saved and queued for
// reprocessing.
const isSuccessStatus = (status) => status >= 200 && status < 300

export const updateTimeDelay = (id, timeDelaySeconds, ymId, tenant_id) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + id + '/time-delay', {
        time_delay: timeDelaySeconds,
        ym_id: ymId,
        tenant_id: tenant_id,
      })
      .then((res) => {
        if (isSuccessStatus(res.status)) {
          dispatch(updateHarvestById(res.data, res.data))
          dispatch(harvestFetched(res.data))
        }
        dispatch(closeModal())
      })
      .catch(() => {
        // http has already replaced this dialog with an alert carrying the
        // server's message, so there is nothing left to close or show.
      })
  }
}

export const changeTestWeight = (id, val) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + id + '/test-weight', { testWeight: val })
      .then((res) => {
        if (res.status === 200) {
          dispatch(updateHarvestById(res.data, res.data))
          dispatch(harvestFetched(res.data))
        }
        dispatch(closeModal())
      })
  }
}

export const updateHarvestHeader = (id, headerObj) => {
  return (dispatch) => {
    return http
      .put('/harvest/' + id + '/update-header', { headerObj })
      .then((res) => {
        if (res.data['request_status'] === 'failed') {
          return 'failed'
        } else {
          if (isSuccessStatus(res.status)) {
            dispatch(updateHarvestById(res.data, res.data))
            dispatch(harvestFetched(res.data))
          }
        }
        dispatch(closeModal())
      })
  }
}

export const updateTare = (id, tareHz, tare, ym_id, tenant_id) => {
  return (dispatch) => {
    let updatedTare = tare
    if (tare > 1) {
      updatedTare = tare / 100.0
    }
    return http
      .post('/harvest/' + id + '/tare', {
        tare_hz: tareHz,
        tare: updatedTare,
        ym_id: ym_id,
        tenant_id: tenant_id,
      })
      .then((res) => {
        dispatch(updateHarvestById(res.data, res.data))
        dispatch(harvestFetched(res.data))
        dispatch(closeModal())
      })
  }
}

export const getYMIDHeaderHarvestSummary = (id, payload) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + id + '/header-summary', payload)
      .then((res) => {
        if (res.data.message ? res.data.message : res.data.Message) {
          dispatch(
            showModal(
              <Alert severity="error">
                {res.data.message ? res.data.message : res.data.Message}
              </Alert>,
              { title: i18next.t('alert') },
            ),
          )
        } else {
          dispatch(harvestHeadersFetched(id, res.data))
        }
      })
  }
}

export const updateCropCal = (id, val, ymId, tenant_id) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + id + '/crop-cal', {
        crop_cal: val,
        ym_id: ymId,
        tenant_id: tenant_id,
      })
      .then((res) => {
        if (isSuccessStatus(res.status)) {
          dispatch(updateHarvestById(res.data, res.data))
          dispatch(harvestFetched(res.data))
        }
        dispatch(closeModal())
      })
      .catch(() => {
        // http has already replaced this dialog with an alert carrying the
        // server's message, so there is nothing left to close or show.
      })
  }
}

export const getHarvestYears = () => {
  return (dispatch) => {
    return http.get('/harvest/years').then((res) => {
      let year = new Date().getFullYear()
      dispatch(harvestYearsFetched(res.data))

      const yearsWithHarvests = getYearsWithHarvests(res.data)
      if (yearsWithHarvests?.length) {
        year = yearsWithHarvests[0]
        if (year) {
          dispatch(setYear(year))
        }
      }
    })
  }
}

export const reprocessHarvest = (id, tenant_id) => {
  return (dispatch) => {
    return http
      .post('/harvest/' + id + '/process', { tenant_id: tenant_id })
      .then((res) => {
        if (res.status === 200) {
          dispatch(updateHarvestById(res.data, res.data))
          dispatch(harvestFetched(res.data))
        }
        dispatch(
          showModal(
            <Alert severity="info">{t('refresh_harvest_received')}</Alert>,
            { title: t('refresh_harvest') },
          ),
        )
      })
      .catch(() => {
        dispatch(
          showModal(
            <Alert severity="error">
              {t('refresh_harvest_received_error')}
            </Alert>,
            { title: t('refresh_harvest') },
          ),
        )
      })
  }
}

export const findHarvestsByFieldYearCrop = (id, year, crop = 'all') => {
  return (dispatch) => {
    if (id && year) {
      const params = { params: { fieldId: id, year: year, cropId: crop } }
      return http.get('/harvest', params).then((res) => {
        dispatch(harvestsFetched(res.data))
      })
    }
  }
}

export const findHarvestsByFieldYearCropA = (id, year, crop = 'all') => {
  return (dispatch) => {
    if (id && year) {
      const params = { params: { fieldId: id, year: year, cropId: crop } }
      return http.get('/harvest', params).then((res) => {
        dispatch(harvestsAFetched(res.data))
      })
    }
  }
}

export const findHarvestsByFieldYearCropB = (id, year, crop = 'all') => {
  return (dispatch) => {
    if (id && year) {
      const params = { params: { fieldId: id, year: year, cropId: crop } }
      return http.get('/harvest', params).then((res) => {
        dispatch(harvestsBFetched(res.data))
      })
    }
  }
}

export const findHarvestsByFieldA = (id) => {
  return (dispatch) => {
    if (id) {
      return http.get('/harvest', { params: { fieldId: id } }).then((res) => {
        dispatch(harvestsAFetched(res.data))
      })
    }
  }
}

export const findHarvestsByFieldB = (id) => {
  return (dispatch) => {
    if (id) {
      return http.get('/harvest', { params: { fieldId: id } }).then((res) => {
        dispatch(harvestsBFetched(res.data))
      })
    }
  }
}

export const fetchHarvestsByField = (fieldId: number) => {
  return http.get('/harvest', { params: { fieldId } })
}

export const getYieldHistogram = (
  id: number,
  layerType: string,
  yieldUnits: string,
): Promise<string> => {
  return http
    .get(`/harvest/${id}/histogram/${layerType}`, {
      params: { yieldUnit: yieldUnits },
    })
    .then((res) => {
      return res.data
    })
}

export const requestBulkExport = (data: {
  export_type: string
  crop_id?: number
  farm_id?: number
  client_id?: number
  year: number
}) => {
  const url = `/harvest/bulk-export`
  return (dispatch) =>
    http.post(url, data).then((res) => {
      dispatch(showModal(<RequestReceived />, {}))
    })
}

export const requestCreateHarvests = (fieldId: number, year: number) => {
  return (dispatch) =>
    http
      .post(`/harvest/field/${fieldId}/create-harvests`, { year })
      .then(() => {
        dispatch(showModal(<CreateHarvestRequestSent />, {}))
      })
}
